<template>
    <div>
        <div v-for="(row, rowIndex) in listRows" :key="rowIndex" data-test-class="grid">
            <div class="row">
                <div
                    v-for="(item, colIndex) in row"
                    :key="rowIndex * cols + colIndex"
                    :class="`col-auto col-md-${bsColClass}`"
                >
                    <slot name="item" :item="item"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            required: true,
        },
        cols: {
            type: Number,
            required: false,
            default: 3,
        },
    },
    computed: {
        listRows() {
            return this.list.reduce((acc, element) => {
                if (!acc.length || acc[acc.length - 1].length == this.cols) {
                    acc.push([element]);
                } else {
                    acc[acc.length - 1].push(element);
                }
                return acc;
            }, []);
        },
        bsColClass() {
            return Math.floor(12 / this.cols);
        },
    },
};
</script>

<style scoped></style>
